
import { computed, defineComponent, getCurrentInstance, ref } from 'vue'
import { DefaultImage, EpbButton, EpbCard, EpbPill, EpbText } from '../shared'

export default defineComponent({
  name: 'PromotionCard',
  components: {
    EpbPill,
    EpbButton,
    EpbText,
    EpbCard,
    DefaultImage,
  },
  props: {
    image: {
      type: String,
      default: undefined,
    },
    title: {
      type: String,
      default: undefined,
    },
    subtitle: {
      type: String,
      default: undefined,
    },
    buttonText: {
      type: String,
      default: undefined,
    },
    buttonAriaText: {
      type: String,
      default: undefined,
    },
    isBanner: Boolean,
    mobile: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const {
      proxy: { $epb },
    } = getCurrentInstance()

    const messages = $epb.messages.tools.promotions.preview

    const baseClass = 'epb-promotion-card'
    const classes = computed(() => {
      return [
        baseClass,
        {
          [`${baseClass}--mobile`]: props.mobile && !props.isBanner,
          [`${baseClass}--banner`]: props.isBanner,
        },
      ]
    })

    const smallFooter = computed(() => props.title && !props.subtitle && !props.buttonText)
    const isWideHorizontalCard = computed(
      () => !props.title && !props.subtitle && !props.buttonText,
    )
    const showFooter = computed(() => props.title || props.subtitle || props.buttonText)

    const showType = ref<boolean>(props.mobile !== undefined && !props.isBanner)

    return {
      messages,
      baseClass,
      classes,
      smallFooter,
      showFooter,
      isWideHorizontalCard,
      showType,
    }
  },
})
